<app-header-page *ngIf="headerVisible">
    <h1>{{ 'HEADERS.ASSIGNMENTS' | translate }}</h1>
</app-header-page>

<div class="btn-group mb-3">
    <button (click)="modalService.openTemplateModal(createAssigmentModal)"
            class="btn btn-success"
    >
        <span>Создать</span>
    </button>
</div>

<table *ngIf="assignments"
       class="table"
>
    <thead>
    <th>Название</th>
    <th>Дата создания</th>
    <th>Автор</th>
    <th>Статус</th>
    </thead>

    <tbody>
    <ng-container *ngIf="!assignments.length">
        <tr>
            <td [attr.colspan]="6"
                class="text-center"
            >
                <b>{{ 'EMPTY_LISTS.TASKS' | translate }}</b>
            </td>
        </tr>
    </ng-container>
    <ng-container *ngFor="let assignment of assignments; let i = index">
        <tr (click)="changeAssignment(assignment)"
            class="table-light"
            role="button"
        >
            <td>
                <span>{{ assignment.title }}</span>
            </td>
            <td>
                <span>{{ helpers.formatDate(assignment.created_at) }}</span>
            </td>
            <td>
                <span *ngIf="assignment.author">{{ helpers.shortFullName(assignment.author) }}</span>
                <span *ngIf="!assignment.author"><i>Загрузка...</i></span>
            </td>
            <td>
                <span>{{ assignment.status }}</span>
            </td>
        </tr>
        <tr *ngIf="selectedAssignment && selectedAssignment.id === assignment.id"
            class="desc">
            <td colspan="6">
                <div [innerHTML]="selectedAssignment.content"
                     style="word-break: break-all;"></div>
                <p *ngIf="!selectedAssignment.content"> {{ 'EMPTY_FIELDS.DESCRIPTION' | translate }}</p>
                <button (click)="changeAssignment(assignment)"
                        class="btn btn-link"
                        data-action="openContract"
                >
                    Поручение детально >>
                </button>
            </td>
        </tr>
    </ng-container>
    </tbody>
</table>

<ng-template #createAssigmentModal
             let-modal
>
    <app-button-modal-close (closeEmit)="description = ''"
                            [modal]="modal"
    ></app-button-modal-close>

    <div class="modal-body">
        <h1>Создать поручение</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #assignmentName
               class="form-control"
               required>

        <h2>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <div>
            <app-component-ckeditor
                    (emitFinish)="description = $event[1]"
                    [isShowButtons]="false"
            ></app-component-ckeditor>
        </div>

        <button (click)="createAssignment(assignmentName.value, modal)"
                class="btn btn-success mt-1"
                data-action="createAssignment"
        >
            <span>{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>
